import React from 'react';

// 图片状态
export enum ImageStatus {
  // loading状态，可能是压缩中，网络请求中
  Loading = 1,
  // 成功状态，可能是压缩完成，网络请求成功
  Success = 2,
  // 错误状态，可能是格式校验错误、压缩报错、网络请求报错
  Error = 3,
}

// 图片错误类型
export enum ImageError {
  // 图片格式错误
  FileFormatError = 1,
  // 图片体积过大（字节，非宽高）
  SizeError = 2,
  // 图片压缩异常
  CompressError = 3,
  // 图片上传网络请求异常
  NetworkError = 4,
  // 未知异常
  UnknowError = 99,
  // 没有错误
  None = -1,
}

export interface IImageErrorInfo {
  // 图片错误类型
  error?: ImageError;
  // 图片错误描述
  errorMsg?: string;
}

// 图片对象类型
export interface IStatusImage extends IImageErrorInfo {
  // 唯一id，用于列表渲染时，避免组件复用导致 渲染异常问题
  uniqKey?: string;
  // 图片链接，可以是完整url链接、dataURL、ObjectURL
  src: string;
  // 上传模式为COS时，需要保存上传至COS的path
  path?: string;
  // 图像的file对象
  file?: File;
  // 图片状态
  status: ImageStatus;
  // 图片上传进度 0~100的数值，表示百分比
  progress?: number;
}

// 上传模式
export enum UploadMode {
  // 对接腾讯云的上传模式
  COS = 1,
}

// 上传成功 返回image的类型
export interface IUploadSuccessImage {
  // 图片链接，dataURL
  src?: string;
  // 图片COS的存储path，别名key
  path?: string;
  // 图片File对象
  file?: File;
}

// 上传成功 返回数据的类型
interface IUploadSuccessPayload {
  // 上传成功的图片
  success: IUploadSuccessImage[];
  // 上传失败的图片
  error: IUploadSuccessImage[];
}

// IStatusImageList组件props类型
export interface IStatusImageListProps {
  // status images 列表数据
  imagesData: IStatusImage[];
  // 删除图片的回调
  onDelete: (image: IStatusImage) => void;
  [key: string]: any;
}

// 状态图片组件props类型
export interface IStatusImageItemProps extends IStatusImage {
  // 删除图片的回调
  onDelete?: (image: IStatusImage) => void;
  [key: string]: any;
}

// IImagesUploaderBtn组件props类型
export interface IImagesUploaderBtnProps {
  // 是否允许多选
  multiple?: boolean;
  // 允许上传的文件mimeType
  accept?: string;
  // 是否禁用
  disabled?: boolean;
  // 是否需要上传图片说明
  isNeedUnloadModalDesc?: boolean;
  // change事件
  onChange?: (e: any) => void;
  [key: string]: any;
}

export interface IImagesUploaderProps {
  className?: string;
  style?: React.CSSProperties;

  // 最多上传图片数量
  max?: number;
  // 是否允许批量上传
  multiple?: boolean;
  // 接受的图片格式
  accept?: string;
  // 上传模式
  type?: UploadMode;
  // 是否启用上传进度功能
  enabledProgress?: boolean;
  // 是否启用图片压缩功能
  enabledCompress?: boolean;
  // 启用图片压缩时，预计最大接受的图片大小，单位为B
  maxSize?: number;
  // 上传模式为COS时，取消是否自动从COS删除本次临时上传的图片
  autoDeleteWhenCancel?: boolean;
  // 上传模式为COS时，文件存储路径
  cosPath?: string;
  // 图片压缩报错提示文案
  compressErrorMsg?: string;
  // 图片上传网络报错提示文案
  networkErrorMsg?: string;
  // 未知异常报错提示文案
  unknowErrorMsg?: string;
  // 上传成功回调，通过该回调获取 图片数据
  onUploadSuccess?: (payload: IUploadSuccessPayload) => void;
  // 删除成功回调，通过该回调 更新 父组件的图片数据
  onDeleteSuccess?: (payload: { path: string; }) => void;
}

// ImagesUploader组件实例类型，用于ref引用该组件，申明可以访问哪些属性、方法
export interface IImagesUploaderInstance {
  deleteImgs: () => Promise<void>;
}
